<template>
  <h1>Service View</h1>
</template>

<script>
export default {};
</script>

<style></style>
